export default __webpack_public_path__ + "static/media/ws.17e330de.svg";